import React, { useEffect, useState } from 'react';
import styles from 'routes/adminMobile/pages/AdminMobileStats.module.css';
import { mainBgColor, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileStoreSaleStat from 'routes/adminMobile/components/AdminMobileStoreSaleStat';
import AdminMobileWeekSaleBest from 'routes/adminMobile/components/AdminMobileWeekSaleBest';
import AdminMobileBuyerStat from 'routes/adminMobile/components/AdminMobileBuyerStat';

// 테스트 지점 데이터
import testStoreData from 'routes/adminMobile/commonVar/testStoreData';

// 테스트 상품 데이터
import testProductData from 'routes/adminMobile/commonVar/testProductData';

// 테스트 구매자 데이터
import testBuyerData from 'routes/adminMobile/commonVar/testBuyerData';

// 연령대 그룹을 가져오는 함수
import { getAgeGroups, getOverallAgeGroups } from 'routes/adminMobile/commonFn/ageUtils';

// 전 매장 주간 판매량 BEST를 가져오는 함수
import calculateOverallProductSales from 'routes/adminMobile/commonFn/calculateOverallProductSales';

const AdminMobileStats = () => {
    // 조인된 데이터를 저장할 상태
    const [joinedData, setJoinedData] = useState([]);

    // 전체 성별 이용자 수 및 성별 비율을 저장할 상태
    const [statsGenderData, setStatsGenderData] = useState({
        totalMale: 0,
        totalFemale: 0,
        totalUsers: 0,
        maleRatio: 0,
        femaleRatio: 0,
    });

    // 연령별 이용자 수를 저장할 상태
    const [ageGroups, setAgeGroups] = useState({});

    // 데이터 조인하기
    useEffect(() => {
        // 조인된 데이터를 만들기 위한 연산 수행
        const newData = testStoreData.map(store => {
            // 각 지점별로 구매자 데이터와 상품 데이터를 찾아서 조합
            const buyers = testBuyerData.filter(buyer => store.buyerNo.includes(buyer.buyerNo));
            const products = testProductData.filter(product => buyers.flatMap(buyer => buyer.productNo).includes(product.productNo));

            // 각 구매자별로 구매한 상품의 총 개수를 합산
            const totalQuantity = buyers.flatMap(buyer => buyer.productCnt).reduce((acc, curr) => acc + curr, 0);

            // 각 구매자별로 구매한 상품의 총 매출액을 합산
            const totalSales = buyers.flatMap(buyer => buyer.productCnt.map((cnt, index) => cnt * products[index].productSalesPrice)).reduce((acc, curr) => acc + curr, 0);

            // 각 성별 이용자 수 계산
            const maleUsers = buyers.filter(buyer => buyer.buyerGender === 'male').length;
            const femaleUsers = buyers.filter(buyer => buyer.buyerGender === 'female').length;

            // 각 연령별 이용자 수 계산
            const ageGroups = getAgeGroups(buyers);

            return {
                store,
                buyers,
                products,
                totalQuantity,
                totalSales,
                maleUsers,
                femaleUsers,
                ageGroups,
            };
        });

        // 전체 성별 이용자 수 및 성별 비율 계산
        const totalMale = newData.reduce((acc, curr) => acc + curr.maleUsers, 0);
        const totalFemale = newData.reduce((acc, curr) => acc + curr.femaleUsers, 0);
        const totalUsers = totalMale + totalFemale;
        const maleRatio = totalMale / totalUsers;
        const femaleRatio = totalFemale / totalUsers;
        
        // 전체 성별 이용자 수 및 성별 비율 상태 업데이트
        setStatsGenderData({
            totalMale,
            totalFemale,
            totalUsers,
            maleRatio,
            femaleRatio,
        });

        // 연령별 이용자 수 상태 업데이트
        setAgeGroups(getOverallAgeGroups(newData));

        // 조인된 데이터 설정
        setJoinedData(newData);
    }, []);
    //
    //
    //

    // 매장 전체의 상품별 판매 개수, 상품 제목, 판매 가격, 이미지 계산
    const overallProductSales = calculateOverallProductSales(joinedData, testProductData);
    //

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>통계</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 지점별 판매량 */}
                        <AdminMobileStoreSaleStat storeData={joinedData} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 주간 판매량 BEST */}
                        <AdminMobileWeekSaleBest products={overallProductSales} />
                    </FlexChild>
                    <FlexChild>
                        {/* 구매자, 연령 통계 */}
                        <AdminMobileBuyerStat buyers={[ statsGenderData, ageGroups ]} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );
};

export default AdminMobileStats;